"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        var documentConstants;
        (function (documentConstants) {
            /** 200 GB max block blob size. */
            documentConstants.FILE_UPLOAD_MAX_BLOB_SIZE = 204800;
            /** The chunk size when doing upload chunking. */
            documentConstants.DEFAULT_CHUNK_SIZE = 1024000;
            /** The threshold at which to begin chunking files during upload. */
            documentConstants.DOCUMENT_UPLOAD_CHUNKING_SIZE_THRESHOLD = 25000000;
        })(documentConstants = controls.documentConstants || (controls.documentConstants = {}));
    })(controls = $dyn.controls || ($dyn.controls = {}));
    var util;
    (function (util) {
        /**
         * This function generates a pseudo ID. First digit is random and
         * the rest is number of millionseconds since 2013, March, 25 UTC time,
         * in base32. This is reasonably unique within limited scope.
         * @returns A unique pseudo ID.
         */
        function generatePseudoId() {
            var d = Date.UTC(2013, 2, 25, 0, 0, 0);
            var myTime = new Date();
            var diff = myTime - d;
            var randomnumber = Math.floor(Math.random() * 32);
            return (randomnumber.toString(32) + diff.toString(32)).toUpperCase();
        }
        util.generatePseudoId = generatePseudoId;
        util.hasJQueryFileUploadLoaded = $dyn.observable(false);
        util.hasJQueryFileUploadSubmitted = false;
        var JQueryFileUploadLibrary = [
            "Scripts/ext/load-image.all.min-2.12.2.js",
            "Scripts/ext/canvas-to-blob.min-3.7.0.js",
            "Scripts/ext/jquery.fileupload-9.18.0.js",
            "Scripts/ext/jquery.fileupload-process-9.18.0.js",
            "Scripts/ext/jquery.fileupload-image-9.18.0.js"
        ];
        /** Loads the JQuery file upload scripts if the scripts haven't already been loaded. */
        function loadJQueryFileUpload() {
            if (!util.hasJQueryFileUploadLoaded()) {
                if (!util.hasJQueryFileUploadSubmitted) {
                    var scriptsLoaded = $dyn.observable(false);
                    $dyn.observe(scriptsLoaded, function (value) {
                        if (value && !$dyn.value(util.hasJQueryFileUploadLoaded) && $(document).fileupload) {
                            util.hasJQueryFileUploadLoaded(true, true);
                            return false;
                        }
                    });
                    $dyn.util.includeJavaScripts(JQueryFileUploadLibrary, 0, scriptsLoaded);
                    util.hasJQueryFileUploadSubmitted = true;
                }
            }
        }
        util.loadJQueryFileUpload = loadJQueryFileUpload;
        /**
         * Gets the file name without an extension.
         * @param fileName The name of the file from which to extract the file name without an extension.
         * @returns The file name without an extension.
         */
        function GetFileNameWithoutExtension(fileName) {
            if (!fileName) {
                return "";
            }
            var lastIndex = fileName.lastIndexOf(".");
            var trimmedFileName;
            if (lastIndex >= 0) {
                trimmedFileName = fileName.substring(0, lastIndex);
            }
            else {
                trimmedFileName = fileName;
            }
            return trimmedFileName;
        }
        util.GetFileNameWithoutExtension = GetFileNameWithoutExtension;
        /**
         * Gets the file extension e.g. ".txt"
         * @param fileName The name of the file from which to extract the file extension.
         * @returns The file extension.
         */
        function GetFileExtension(fileName) {
            var fileExtension = "";
            if (!fileName) {
                return fileExtension;
            }
            var lastIndex = fileName.lastIndexOf(".");
            if (lastIndex >= 0) {
                fileExtension = fileName.substring(lastIndex, fileName.length);
            }
            return fileExtension;
        }
        util.GetFileExtension = GetFileExtension;
        /**
         * Checks if the file has the required type.
         * @param fileExt Curent fileExt e.g. ".txt"
         * @param fileMIMEType e.g. "image/jpeg"
         * @param fileFilter e.g. "video/*,image/jpeg,image/gif,image/png,application/pdf,image/x-eps,.jpg,.png,.gif,.txt"
         *                   The accept attribute may be specified to provide user agents with a hint of what file types will be accepted.
         *                   If specified, the attribute must consist of a set of comma-separated tokens, each of which must be an ASCII case-insensitive match for one of the following:
         *                     The string audio/*:  Indicates that sound files are accepted.
         *                     The string video/*:  Indicates that video files are accepted.
         *                     The string image/*:  Indicates that image files are accepted.
         *                     A valid MIME type with no parameters: Indicates that files of the specified type are accepted.
         *                     A string whose first character is a U+002E FULL STOP character (.): Indicates that files with the specified file extension are accepted.
         * @returns A value indicating whether the file extension is valid.
         */
        function CheckValidFileExtension(fileExt, fileMIMEType, fileFilter) {
            var e_1, _a;
            if (typeof fileFilter === "undefined" || fileFilter.trim() === "") {
                // Without file filter
                return true;
            }
            fileExt = fileExt.toLowerCase();
            fileMIMEType = fileMIMEType.toLowerCase();
            fileFilter = fileFilter.toLowerCase();
            var fileTypes = fileFilter.split(",");
            try {
                for (var fileTypes_1 = __values(fileTypes), fileTypes_1_1 = fileTypes_1.next(); !fileTypes_1_1.done; fileTypes_1_1 = fileTypes_1.next()) {
                    var fileType = fileTypes_1_1.value;
                    fileType = fileType.trim();
                    if (fileType.length < 1) {
                        continue;
                    }
                    if (fileType[0] === ".") {
                        // Compares file ext
                        if (fileType === fileExt) {
                            return true;
                        }
                    }
                    else {
                        // Compares file MIME type
                        var curMIMETypes = fileMIMEType.split("/");
                        var filterMIMETypes = fileType.split("/");
                        if (filterMIMETypes.length === 1 || filterMIMETypes[1].trim() === "*") {
                            // Compares high level MIME type
                            if (curMIMETypes[0] === filterMIMETypes[0]) {
                                return true;
                            }
                        }
                        else {
                            // Compares full MIME type
                            if (fileMIMEType === fileType) {
                                return true;
                            }
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (fileTypes_1_1 && !fileTypes_1_1.done && (_a = fileTypes_1.return)) _a.call(fileTypes_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return false;
        }
        util.CheckValidFileExtension = CheckValidFileExtension;
    })(util = $dyn.util || ($dyn.util = {}));
    var ui;
    (function (ui) {
        var DocuUploadStyle;
        (function (DocuUploadStyle) {
            DocuUploadStyle["StandardStyle"] = "Standard";
            DocuUploadStyle["MinimalStyle"] = "Minimal";
        })(DocuUploadStyle = ui.DocuUploadStyle || (ui.DocuUploadStyle = {}));
        var FileUploadStyle;
        (function (FileUploadStyle) {
            FileUploadStyle["StandardStyle"] = "Standard";
            FileUploadStyle["MinimalStyle"] = "Minimal";
            FileUploadStyle["MinimalWithFileNameStyle"] = "MinimalWithFilename";
        })(FileUploadStyle = ui.FileUploadStyle || (ui.FileUploadStyle = {}));
    })(ui = $dyn.ui || ($dyn.ui = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=DocumentManagementHelpers.js.map
